import { FragmentType, parseFragmentData } from '@mp/graphql/generated';
import { EducationItemFragment } from '../graphql';
import React from 'react';
import { Box, Label, Text } from '@medely/ui-kit';
import { DisplayHelpers } from '@mp/utils';

type EducationItemInfoProps = {
  educationItem?: FragmentType<typeof EducationItemFragment>;
};

export const EducationItemInfo = ({
  educationItem: inputEducationItem,
}: EducationItemInfoProps) => {
  const educationItem = parseFragmentData(EducationItemFragment, inputEducationItem);

  return (
    <Box flex={1}>
      <Label size="m" testId="education-item-school-name">
        {educationItem?.school_name}
      </Label>
      <Text size="m" color="text.secondary" testId="education-item-field-of-study">
        Degree: {educationItem?.degree_type}
      </Text>
      <Text size="m" color="text.secondary" testId="education-item-program-type">
        Program Type: {educationItem?.field_of_study}
      </Text>
      <Text size="m" testId="education-item-date">
        {educationItem?.end_date ? DisplayHelpers.getDate(educationItem.end_date) : ''}
      </Text>
    </Box>
  );
};
